export enum PAGES {
  HOME = "Home",
  ZIP_COVERAGE = "Zip Coverage",
  CLIENTS = "Clients",
  PARCEL_CENTERS = "Parcel Centers",
  FDP = "FDP",
  FDP_ZIPCODE = "FDP Zipcode",
  GC_IMPORT = "GC Import",
  SHIPMENTS = "Shipments",
  PACKAGES = "Packages",
  OUT_OF_AREA = "Out Of Area",
  PACKAGES_ARRIVED = "Packages Arrived",
  PACKAGES_FOR_REVIEW = "Packages For Review",
  MAX_ATTEMPT = "Max Attempt",
  MISSING_MANIFEST = "Missing Manifest",
  USER = "User",
  ROLE = "Role",
  ROUTE_REPORT = "Route Report",
  MIDDLE_MILE = "Middle Mile",
  RECEIVING = "Receiving",
  STORE_MANIFEST = "Store Manifest",
  PC_MANIFEST = "Pc Manifest",
  RETURN_TO_STATION = "Return To Station",
  EVENT_TYPE = "Event Type",
  VEHICLE_LOAD_SCAN = "Vehicle Load Scan",
  DEDICATED_DELIVERY = "Dedicated Delivery",
  ROUTE_PROGRESS_DEDICATED = "Route Progress - Dedicated",
  SFTP = "SFTP",
  ADD_RETURN_TO_STATION = "Add RTS",
  INVOICE_LIST = "Invoice",
  BEANS_INTEGRATION = "BeansIntegration",
  KNOWLEDGE_HUB = "KnowledgehubPage"
}
